var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSocialTwitter = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 17,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 20h-15A2.5 2.5 0 0 1 0 17.5v-15A2.5 2.5 0 0 1 2.5 0h15A2.5 2.5 0 0 1 20 2.5v15a2.5 2.5 0 0 1-2.5 2.5Z",
  fill: "#1D9BF0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.68 15.08c4.715 0 7.295-3.91 7.295-7.295 0-.11 0-.22-.005-.33.5-.36.935-.815 1.28-1.33-.46.205-.955.34-1.475.405a2.58 2.58 0 0 0 1.13-1.42 5.1 5.1 0 0 1-1.63.62 2.56 2.56 0 0 0-1.87-.81 2.567 2.567 0 0 0-2.5 3.15A7.28 7.28 0 0 1 4.62 5.39a2.57 2.57 0 0 0 .795 3.425 2.593 2.593 0 0 1-1.16-.32v.035c0 1.24.885 2.28 2.055 2.515a2.5 2.5 0 0 1-.675.09 2.52 2.52 0 0 1-.48-.045 2.564 2.564 0 0 0 2.395 1.78 5.142 5.142 0 0 1-3.795 1.065A7.293 7.293 0 0 0 7.68 15.08Z",
  fill: "#fff"
})));
export { SvgSocialTwitter as ReactComponent };